import { createServerFn } from "@tanstack/react-start";
import { getObservationById as makeRequest } from "@/network/queries/get-observation-by-id";
import { QueryKeysConfig } from "@/config/query-keys";
import { getServerCacheQueryClient } from "@/network/cache-query-client";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import * as v from "valibot";

const Schema = v.object({
  id: v.pipe(v.string(), v.maxLength(256)),
});

export const getObservationById = createServerFn({ method: "GET" })
  .middleware([loggingMiddleware])
  .validator((data: v.InferInput<typeof Schema>) => v.parse(Schema, data))
  .handler(async ({ data: { id } }) => {
    const res = await getServerCacheQueryClient().ensureQueryData({
      queryKey: [QueryKeysConfig.observation, id],
      queryFn: () => makeRequest(id),
      revalidateIfStale: true,
    });
    return res;
  });
